module.exports = __webpack_public_path__ + "img/fr_upgrade_page_banner.2b5aac99.gif";